/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ExperimentIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M17 16.313c0 1.312-.375 2.562-1.062 3.687l-2.5 4H26.5L24 20c-.687-1.125-1-2.375-1-3.687V7h-6zM26 7v9.313c0 .75.188 1.5.563 2.125l6.75 11c.437.687.687 1.437.687 2.25C34 34.063 32 36 29.625 36H10.313A4.32 4.32 0 0 1 6 31.688c0-.813.188-1.563.625-2.25l6.75-11c.375-.625.625-1.375.625-2.125V7h-.5c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h13c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5z"/>}
        </IconWrapper>);
}
